
import { Button } from "@/components/ui/button";

export function CompanyError() {
  return (
    <div className="py-4 text-center">
      <p className="text-muted-foreground">Unable to load company information. Please try again later.</p>
      <Button 
        variant="outline" 
        onClick={() => window.location.reload()}
        className="mt-4"
      >
        Refresh Page
      </Button>
    </div>
  );
}
